import { Link } from "react-router-dom";
import { BOM } from "../../../services/definedMethod";

/*!*******************************************************************************!
  !*** CHARGE & FEE API CONFIG                                                       ***!
  \*******************************************************************************/
export const chargeApi = {
  // Charges
  // Charges: BOM.baseUrl("charges", "treasury"),
  Charges: BOM.baseUrl("charges"),
  Paymenttypes: BOM.baseUrl("paymenttypes"),
};

/*!*******************************************************************************!
  !*** CHARGE & FEE LABEL CONFIG                                                       ***!
  \*******************************************************************************/
export const chargeLabel = {
  manageCharge: "Manage Charge",
  addFeeFrequency: "Add Fee Frequency ",
  chargeDetail: "Charge Detail",
  chargeId: "Charge Id",
  chargeName: "Charge Name",
  chargeAppliesTo: "Charge Applies To",
  isPenalty: "Is Penalty ?",
  inactive: "Inactive",
  chargeFrequency: "Charge Frequency",
  frequencyInterval: "Frequency Interval",
  chargeCalculationType: "Charge Calculation Type",
  chargePaymentMode: "Charge Payment Mode",
  chargeTimeType: "Charge Time Type",
  freeWithdrawal: "Free Withdrawal",
  isPaymentType: "Is Payment Type",
  restartFrequency: "Restart Frequency",
  newCharge: "New Charge",
  editCharge: "Edit Charge",
  currency: "Currency",
  amount: "Amount",
  enableCharge: "Enable Charge",
  active: "Active",
  status: "Status",
  chargeSetup: "Charge Setup",
  newChargeMsg: "Charge was successfully created",
  editChargeMsg: "Charge was successfully edited",
  deleteChargeMsg: "Charge was successfully deleted",
  generalInfo: "General Information",
  dueDate: "Due Date",
  repeatsEvery: "Repeats Every",
  incomeFromCharge: "Income From Charge",
  taxGroup: "Tax Group",
  chargesAndFees: "Charges & Fees",
  enablePaymentType: "Enable Payment Type",
  enableFreeWithdrawal: "Enable Free Withdrawal",
  paymentTypes: "Payment Types",
  noOfFreeWithdrawals: "No. of Free Withdrawals",
  restartCountingEvery: "Restart Counting Every",
  restartCountFrequency: "Restart Count Frequency",
};

/*!*******************************************************************************!
    !*** CHARGE & FEE STATIC CONFIG                                                      ***!
    \*******************************************************************************/
export const chargeStatic = {
  manageChargeItems: [{ title: chargeLabel.manageCharge }],
  detailChargeItems: [
    { title: <Link to="/prd1000">{chargeLabel.manageCharge}</Link> },
    { title: chargeLabel.chargeDetail },
  ],
  newChargeItems: [
    { title: <Link to="/prd1000">{chargeLabel.manageCharge}</Link> },
    { title: chargeLabel.newCharge },
  ],
  editChargeItems: [
    { title: <Link to="/prd1000">{chargeLabel.manageCharge}</Link> },
    { title: chargeLabel.editCharge },
  ],
  statusData: [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
  ],
  trueFalseData: [
    { label: "True", value: true },
    { label: "False", value: false },
  ],
  viewChargeItems: [{ title: chargeLabel.chargesAndFees }],
  viewChargeBreadCrumbItems: [
    { title: <Link to="/view-charge">{chargeLabel.chargesAndFees}</Link> },
    { title: chargeLabel.chargeDetail },
  ],
};
